
export const splice = (oldString: string, start: number, newSubString: string): string => {
  return `${oldString.slice(0, start)}${newSubString}${oldString.slice(start)}`;
};

export const capitilizeFirstLetter = (text: string): string => {
  return `${text.charAt(0).toUpperCase() + text.slice(1)}`;
};
